import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => {
  return {
    path: "lti-tools/:appId",
    component: withAsyncRouteLoading(() =>
      Promise.all([
        import(/* webpackChunkName: "lti-app-launch" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    ),
    childRoutes: [],
  };
};
